
export default {
	
	inserted(el, binding) {
        if ( binding && binding.value ) {
            el.addEventListener('click', function(e) {
                let target = document.querySelector(binding.value);
                
                if ( target ) {
                    window.scrollToTarget(target);
                }
            });
        }
	},
	
};
